import { render, staticRenderFns } from "./RegisterPassword1.vue?vue&type=template&id=62504c44"
import script from "./RegisterPassword1.vue?vue&type=script&lang=js"
export * from "./RegisterPassword1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports